export enum BusinessUnitsEnum {
  WM = "WM",
  LT = "LT",
  TE = "TE"
}
